import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { CreditosConEmpleadosListComponent } from './creditos-con-empleados-list.component';
import { CreditosConEmpleadosService } from './creditos-con-empleados.service';
import { AddFileService } from '../../../shared/components/add-file/add-file.service';
import { LocalDB } from '../../../shared/utils';
import { CreditosConEmpleadosModel } from './creditos-con-empleados.model';
import { consts } from '../../../consts';

@Component({
    selector: 'convfact-creditosconempleadosattachment',
    templateUrl: './creditos-con-empleados-dialog-attachment.component.html',
    styleUrls: ['./creditos-con-empleados.component.css'],
    standalone: false
})
export class CreditosConEmpleadosDialogAttachmentComponent {

  public uid: string = this.data.uid;

  public originEntity: string = "Finanzas";
  public filePath: string = "";
  public loadingFile: boolean = false;
  public imageTempUrl: any = '';

  constructor(
    public dialogRef: MatDialogRef<CreditosConEmpleadosListComponent>,
    public creditosConEmpleadosService: CreditosConEmpleadosService,
    private addFileService: AddFileService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  public uploadFile(event) {
    this.imageTempUrl = null;

    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.loadingFile = true;
      const file: File = fileList[0];
      const formData: FormData = new FormData();
      formData.append('file', file, file.name);

      this.addFileService.attachFile(formData, this.originEntity).then(response => {
        if (response.error) {
          this.displayInfo(response.message);
          this.loadingFile = false;
        } else {
          LocalDB.RemoveForFiles();

          const fileUid = response.uid; // Tenemos el uid del elemento que se ha subidp

          const creditosConEmpleados: CreditosConEmpleadosModel = {
            carencia: 0,
            bankAccountsUid: consts.EMPTY_GUID,
            employeesId: 0,
            employeesName: "",
            importeInicial: 0,
            importePendiente: 0,
            fechaConstitucion: new Date(),
            fechaFinalizacion: new Date(),
            plazo: 0,
            tipoInteres: 0,
            uid: this.uid,
            tipoLiquidaciones: 0,
            filesCreditosConEmpleadosUid: fileUid
          };

          this.creditosConEmpleadosService.editFileAttachment(creditosConEmpleados)
          .then(response => {

            if (response == true) {
              this.displayInfo("Se ha adjuntado el fichero correctemante.");
            }
            else {
              this.displayInfo("No se ha podido adjuntar el fichero");
            }

            this.loadingFile = false;

            this.closeDialog();
          })
          .catch(err => {
            this.loadingFile = false;

            this.displayInfo("No se ha podido adjuntar el fichero");

            this.closeDialog();
          });

        }
      })
    }
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }
}
